import { render } from "./PageHasilKeputusan.vue?vue&type=template&id=4f824f74"
import script from "./PageHasilKeputusan.vue?vue&type=script&lang=js"
export * from "./PageHasilKeputusan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__